import { Controller } from '@hotwired/stimulus'

// Desktop categories and the mobile Menu open the same navigation panel.
export default class extends Controller {
  openSection(event) {
    document.dispatchEvent(new CustomEvent('site-nav:open', {
      // The mobile Menu button reopens the section used last (data-nav-remember);
      // header buttons always open their own section.
      detail: {
        section: event.currentTarget.dataset.navSection,
        trigger: event.currentTarget,
        remember: event.currentTarget.dataset.navRemember === 'true'
      }
    }))
  }

  openSearch() {
    document.dispatchEvent(new CustomEvent('seo-search:open'))
  }
}
